import React, { Suspense, lazy } from 'react';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { RoutePath } from './route/route-path';
import RootPage from './router/root';
import { ToastContainer } from 'react-toastify';
import { SettingProvider } from './router/setting/provider';
import { AuthProvider } from './router/auth/provider';
import { GuestOnly, RequireAuth } from './router/auth/require-auth';

const HomePage = lazy(() => import('./router/home'));
const ClipboardDetailPage = lazy(() => import('./router/clipboard-detail'));
const LoginPage = lazy(() => import('./router/auth/login'));
const RegisterPage = lazy(() => import('./router/auth/register'));
const ForgotPasswordPage = lazy(() => import('./router/auth/forgot-password'));
const ProfilePage = lazy(() => import('./router/auth/profile'));
const QrLoginConfirmPage = lazy(() => import('./router/auth/qr-login-confirm'));

function App() {
  return (
    <SettingProvider>
      <RootPage>
        <BrowserRouter>
          <AuthProvider>
            <Suspense fallback={null}>
              <Routes>
                <Route element={<RequireAuth />}>
                  <Route path={RoutePath.initial} element={<HomePage />} />
                  <Route path={RoutePath.clipDetail} element={<ClipboardDetailPage />} />
                  <Route path={RoutePath.profile} element={<ProfilePage />} />
                </Route>
                <Route element={<GuestOnly />}>
                  <Route path={RoutePath.login} element={<LoginPage />} />
                  <Route path={RoutePath.register} element={<RegisterPage />} />
                </Route>
                <Route path={RoutePath.forgotPassword} element={<ForgotPasswordPage />} />
                <Route path={RoutePath.qrLoginConfirm} element={<QrLoginConfirmPage />} />
              </Routes>
            </Suspense>
          </AuthProvider>
        </BrowserRouter>
        <ToastContainer />
      </RootPage>
    </SettingProvider>
  );
}

export default App;
